<template>
    <button @click="toggle" :class="classes" :disabled='disabled'>
      <slot name="default" />
    </button>
  
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    highlight:{
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableToggle: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'normal'
    }
  },
  methods: {
    toggle() {
      if (this.disableToggle) {
        return;
      }
      const nv = !this.value;
      this.$emit('input', nv);
      this.$emit("toggle", nv);
    }
  },
  computed: {
    classes() {
      if (this.mode === 'normal') {
        if (this.disabled) {
          return ['pbc-toggle-button-disabled', 'pbc-toggle-button']
        } else {
          const classes =['pbc-toggle-button'];
          if (this.value) {
            classes.push('pbc-toggle-button-on');
            classes.push("text-white");
          } else {
            classes.push('pbc-toggle-button-off');
          }
          return classes;
        }
      } else {
        if (this.disabled) {
          return ['pbc-toggle-button-outlined-disabled', 'pbc-toggle-button-outlined']
        } else {
          const classes =['pbc-toggle-button-outlined'];
          if (this.highlight) {
            if (this.value) {
              classes.push('pbc-toggle-button-outlined-on');
            } else {
              classes.push('pbc-toggle-button-outlined-off');
            }
          }
          return classes;
        }
      }
    }
  },
  watch:{
  }
  
}
</script>
